import React from "react";

import {
  styled,
  GlobalStyles,
  Paper,
  Container,
  CircularProgress,
  Alert,
} from "@mui/material";
import Portal from "@mui/material/Portal";

import AppBar from "./AppBar";

const globalStyles = {
  "#root": {
    display: "flex",
    justifyContent: "stretch",
    height: "100vh",
  },
};

const Main = styled("main")`
  flex-grow: 1;
  flex-basis: 100%;
  display: flex;
  flex-direction: column;
  overflow: auto;
`;

const Content = styled("div")`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
`;

const ToolbarRoot = styled(Paper)`
  &:not(:empty) {
    min-height: 56px;
    flex-shrink: 0;
    z-index: 1;
    position: sticky;
    top: 0;
    display: flex;
    align-items: center;
  }
`;
const ToolbarContext = React.createContext();

export default function Layout({ onToggleMode, children }) {
  const [toolbarRef, setToolbarRef] = React.useState();

  return (
    <>
      <GlobalStyles styles={globalStyles} />

      <AppBar onToggleMode={onToggleMode} sx={{ displayPrint: "none" }} />
      <Main id="Layout-Main">
        <ToolbarRoot square ref={setToolbarRef} />

        <Content>
          <ToolbarContext.Provider value={toolbarRef}>
            {children}
          </ToolbarContext.Provider>
        </Content>
      </Main>
    </>
  );
}

const ToolbarContent = styled(Container)(({ theme }) => ({
  padding: theme.spacing(1),
}));

Layout.Toolbar = function Toolbar(props) {
  const toolbarRef = React.useContext(ToolbarContext);

  if (!toolbarRef) return null;

  return (
    <Portal container={toolbarRef}>
      <ToolbarContent {...props} />
    </Portal>
  );
};

Layout.Loading = function () {
  return (
    <Container fixed sx={{ display: "flex", justifyContent: "center", p: 2 }}>
      <CircularProgress />
    </Container>
  );
};

Layout.Error = function ({ children }) {
  return (
    <Container fixed sx={{ p: 2 }}>
      <Alert severity="error">{children}</Alert>
    </Container>
  );
};

Layout.NotFound = function () {
  return <Layout.Error>Page introuvable.</Layout.Error>;
};
